import { Component, inject, OnInit, signal } from '@angular/core';
import {WebcamImage, WebcamInitError, WebcamModule} from 'ngx-webcam';
import { Observable, Subject } from 'rxjs';
import { BrnDialogRef, injectBrnDialogContext } from '@spartan-ng/brain/dialog';
import { HlmButton } from '@spartan-ng/helm/button';
import { HlmSkeletonImports } from '@spartan-ng/helm/skeleton';

@Component({
  selector: 'app-camera-component',
  imports: [WebcamModule, HlmSkeletonImports, HlmButton],
  templateUrl: './camera-component.html',
  styleUrl: './camera-component.css',
})
export class CameraComponent implements OnInit {
  protected readonly dialogRef = inject<BrnDialogRef<any>>(BrnDialogRef);
  protected readonly data? = injectBrnDialogContext<any>();


  photo = signal<WebcamImage | string | null>(null);
  photoData = signal<string | null>(null);
  private stream: MediaStream | null = null;
  isCameraOn = signal(false);
  cameraPermissionsGranted = signal(true);
  permissionState = signal<'requesting' | 'denied' | 'granted'>('requesting');
  trigger:Subject<void> = new Subject<void>();
  videoOptions: MediaTrackConstraints = {
    facingMode: { ideal: 'user' }
  };

  ngOnInit(): void {
    // throw new Error('Method not implemented.');
  }
  ngAfterViewInit() {
    // console.log('Webcam component initialized, checking video element...',this.isCameraOn);

    const checkVideo = () => {
      const videoEl = document.querySelector('webcam video') as HTMLVideoElement;
      if (videoEl && !videoEl.paused && !videoEl.ended && videoEl.readyState >= 2) {
        this.isCameraOn.set(true);
        this.permissionState.set('granted');
      } else if (this.permissionState() !== 'denied') {
        requestAnimationFrame(checkVideo);
      }
      console.log('Checking video element:', this.isCameraOn());
    };
    checkVideo();
  }

  handleInitError(error: WebcamInitError) {
    this.isCameraOn.set(false);
    this.cameraPermissionsGranted.set(false);
    this.permissionState.set('denied');
    // console.error('Webcam initialization error:', error);
  }

  triggerSnapshot(){
    this.trigger.next();
  }
  public get triggerObservable(): Observable<void> {
    return this.trigger.asObservable();
  }

  async handleImageCapture(webImageData: WebcamImage) {
    this.photo.set(webImageData);
    console.log('Captured image data:', webImageData);
    this.photoData.set(webImageData.imageAsDataUrl);
    await this.closeModal(webImageData.imageAsDataUrl);
  }

  async closeModal(photoData?: string) {
    // Stop all media tracks
    const videoElement = document.querySelector('video');
    this.stream = videoElement?.srcObject as MediaStream;

    if (this.stream) {
      this.stream.getTracks().forEach(track => track.stop());
      this.stream = null;
    }
    // this.globalService.modal.canDismiss = true;
    // await this.modalController.dismiss(photoData || null,'photo');
    this.dialogRef.close({data:photoData})
    
  }
  
}
